export default __webpack_public_path__ + "static/media/Learn.20f9375b.svg";